<template>
  <div class="chat d-flex">
    <v-app-bar
      class="elevation-0"
      color="#E5E5EA"
      height="67px"
      clipped-right>
      <v-spacer />
      <span class="mx-auto headline font-weight-medium black--text">{{companyName}}</span>
      <!-- <expire-info /> -->
      <v-spacer />
      <v-btn
        title="Reiniciar"
        fab
        color="transparent"
        depressed
        small
        class="mb-0"
        v-if="showRestart"
        @click="restartChat">
        <span class="refresh-chat">
          <v-icon
            size="24px"
            color="white">mdi-restart</v-icon>
        </span>
      </v-btn>
      <!-- <span class="white--text body-2 ellipsis">Sair</span> -->

      <v-btn
        title="Sair"
        icon
        class="mb-0"
        @click="logout">
        <v-icon
          color="white"
          class="ml-1"
          dark>
          <!-- {{ $root.icons.action.logout }} -->
        </v-icon>
      </v-btn>
    </v-app-bar>
    <v-container
      class="chat-layout"
      pa-0
      ma-0
      fluid
      fill-height>
      <v-layout class="ma-0" row wrap>
        <v-flex v-if="activeConferenceId" sm12 md7 class="video-content align-start pa-0">
          <video-conference :conference="activeConferenceId" />
        </v-flex>

        <!-- <v-flex sm12 md7 class="video-content pa-0">
          <video-conference :conference="activeConferenceId" />
        </v-flex> -->

        <v-flex sm12 :class="activeConferenceId ? 'md5' : 'md12'">
          <v-layout
            wrap
            grid-list-xs>
            <v-flex sm-12 :class="activeConferenceId ? 'chat-content videoEnabled' : 'chat-content'">
              <perfect-scrollbar :options="options">
                <v-layout class="chat-main">
                  <v-container class="py-0 px-0">
                    <v-card
                      ref="list"
                      class="elevation-0 transparent list"
                      height="100%">
                      <v-card-text class="chat-scroll">
                        <template v-for="[date, msgs] in components">
                          <h2
                            :key="date"
                            class="body-1 font-weight-bold text-center black--text">
                            {{ date }}
                          </h2>
                          <dynamic-list-components
                            v-for="component in msgs"
                            :ref="`output-${component.id}`"
                            :key="`output-${component.id}`"
                            :record="component"
                            :type="component.type" />
                        </template>
                        <message-loading v-if="requestInProgress" />
                      </v-card-text>
                    </v-card>
                  </v-container>
                </v-layout>
              </perfect-scrollbar>
            </v-flex>

            <v-flex class="input-area sm12">
              <dynamic-component
                v-if="lastMessage.data.input"
                :ref="`input-${lastMessage.slug}-${lastMessage.id}`"
                :slug="lastMessage.slug"
                :record="lastMessage"
                :type="lastMessage.type"
                @send="responseInput" />

              <guest-input v-else-if="isNegotiation" @send="responseInput"/>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  /* eslint no-unexpected-multiline: 0 */
  /* eslint func-call-spacing: 0 */
  const DynamicListComponents = () => import('@/components/DynamicListComponents')
  const DynamicComponent = () => import('@/components/DynamicComponent')
  const MessageLoading = () => import('@/components/ui/MessageLoading')
  const GuestInput = () => import('@/components/ui/GuestInput')
  import VideoConference from '@/components/VideoConference'
  import { mapGetters } from 'vuex'

  var chatDefault = {
    type: 'Message',
    data: {
      id: 0,
      isBot: false,
      message: '',
      input: false,
      options: null,
    }
  }

  export default {
    components: {
      DynamicListComponents,
      DynamicComponent,
      MessageLoading,
      GuestInput,
      VideoConference
    },
    data () {
      return {
        options: { suppressScrollX: true, wheelPropagation: false },
        showLastMessage: false,
        state: '',
        windowSize: {
          x: 0,
          y: 0
        }
      }
    },
    computed: {
      ...mapGetters({
        components: 'conversations/messages',
        activeConferenceId: 'app/activeConferenceId',
        companyName: 'app/companyName',
        requestInProgress: 'conversations/requestInProgress',
        miniLogo: 'app/miniLogo'
      }),
      lastMessage () {
        let arr = Array.from(this.components)
        arr = arr.length ? arr.last()[1] : []

        return arr.length ? arr.last() : chatDefault
      },
      showRestart () {
        return location.hostname === 'localhost'
      },
      isNegotiation () {
        return this.state === 'negotiation'
      }
    },
    beforeMount () {
      this.firebase.firestore().collection('cases').doc(this.$route.params.caseId).onSnapshot(doc => {
        const data = doc.data()
        const now = new Date().getTime()
        const updatedAtTs = data.updatedAt.toDate().getTime()
        const state = data.state

        if (state === 'initialProposal' && (now - updatedAtTs) / 1000 / 60 / 60 > 24) {
          this.responseInput({ slug: 'Recalculate', topic: this.$route.params.caseId })
        }

        this.state = data.state
      })
    },
    mounted () {
      this.$store.dispatch('conversations/getList', this.$route.params.caseId)
      this.hotJar()
      this.mouseFlow()
    },
    methods: {
      logout () {
        this.$store.dispatch('global/userLogout')
      },
      responseInput (option) {
        this.$store.dispatch('conversations/answer', option)
      },
      asyncChat (obj, delay) {
        return new Promise(() => {
          setTimeout(() => {
            this.setDataLocalStorage(obj)
            this.components.push(obj)
          }, delay)
        })
      },
      setDataLocalStorage (obj) {
        let result = JSON.stringify(obj)
        let chat = JSON.parse(localStorage.getItem('chat'))
        let chatFiltered = chat.filter((item) => {
          return item !== obj
        })

        chatFiltered.push(result)
        localStorage.setItem('chat', JSON.stringify(chatFiltered))
      },
      restartChat () {
        const caseRef = this.firebase.firestore().collection('cases').doc(this.$route.params.caseId)
        this.firebase.firestore().collection('conversations').where('case', '==', caseRef).get().then(snapshot => {
          var batch = this.firebase.firestore().batch()
          snapshot.forEach(caseRecord => batch.delete(caseRecord.ref))
          batch.commit().then(() => {
            console.log('chat limpo')
            this.$store.dispatch('conversations/getList', this.$route.params.caseId)
          });
        })

        this.anime({
          targets: '.refresh-chat',
          rotate: [0, -360],
          duration: 1000,
          easing: 'easeInOutSine'
        })
      },
      hotJar () {
        (function (h, o, t, j, a, r) {
          h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) }
          h._hjSettings = {hjid: 1129192, hjsv: 6}
          a = o.getElementsByTagName('head')[0]
          r = o.createElement('script')
          r.async = 1
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
          a.appendChild(r)
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
      },
      mouseFlow () {
        (function () {
          window._mfq = window._mfq || []
          var mf = document.createElement('script')
          mf.type = 'text/javascript'
          mf.async = true
          mf.src = '//cdn.mouseflow.com/projects/cc0cfdd5-e956-4a2b-8254-4d624efa0bc9.js'
          document.getElementsByTagName('head')[0].appendChild(mf)
        })()
      }
    }
  }
</script>

<style lang="sass">
  @import '../assets/style/app'

  $spaceTopbar: 50px
  $radius: 10px
  $inputArea: 76px

  .v-application .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat),
  .theme--dark .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat)
    background: rgba(0,0,0,.12)!important
    color: rgba(0,0,0,.26)!important

  .chat
    height: 100vh
    overflow: hidden

    .v-app-bar
      position: fixed
      top: 0
      z-index: 2

    .chat-layout
      margin-top: 67px
      .video-content
        margin-top: 65px

    .time-hour
      font-size: 14px
      color: $textColor

    .input-component
      opacity: 0
      transform: translateY(400px)

      > .v-card
        width: 100%

      .container
        max-width: 900px

    .table-chat,
    .box-card
      margin: 0 50px 30px
      border-radius: $radius

      .table
        border-radius: $radius

      tbody
        td
          color: $darkGray

        tr
          &:nth-child(odd) td
            background: $bgColor

    .input-area
      // width: 100%
      min-height: $inputArea
      padding: 0
      // position: fixed
      // bottom: 0
      // z-index: 2
      background: #F8F8F9
      @extend %default-shadow

      .container
        padding: 20px

    .logo-topbar
      display: flex
      align-items: center
      color: $light

      h1
        display: flex
        margin-right: 10px

      p
        font-size: 16px

    .logo
        width: 40px

  .chat-content
    // margin-top: $spaceTopbar
    // height: calc(100vh - 193px)

    .ps
      height: calc(100vh - 100px)

  .chat-main
    max-width: 1324px
    margin: 0 auto

    > .container
      .chat-scroll
        padding-top: $spaceTopbar * 2
        // @extend %scroll

  @media screen and (max-width: $max-mobile)
    .chat
      .logo
        width: 40px

      .chat-layout
        .video-content
          height: 175px
          margin-top: 67px
        .chat-content
          margin-top: 67px
          .ps
            height: calc(100vh - 170px)
        .chat-content.videoEnabled
          margin-top: 0px
          .ps
            height: calc(100vh - 348px)
            margin-top: -90px

        .input-area
          width: 100%
          position: fixed
          bottom: 0
          z-index: 2

      .ellipsis
        max-width: 100%

      .table-chat,
      .box-card
        margin: 0 5px 30px

      .btn-mobile-prev i
        margin-left: 5px

      .btn-mobile-save
        margin-right: 0
        margin-left: 0

      .btn-mobile-prev
        margin-right: 0
</style>
